var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.userIsLoggedIn
    ? _c(
        "v-container",
        {
          staticClass: "d-flex justify-center overflow-auto",
          attrs: { fluid: "" },
        },
        [
          _c("LoginForm", {
            ref: "loginForm",
            attrs: {
              stepToShow: _vm.loginStep,
              loading: _vm.loading.login,
              errors: _vm.loginErrors,
            },
            on: { onLoginSubmit: _vm.handleLogin },
          }),
        ],
        1
      )
    : _vm.canShowForm && _vm.userIsLoggedIn
    ? _c("Layout", {
        attrs: {
          showNav: _vm.step == 1,
          showSort: _vm.showSort,
          alignTop: _vm.step == 1,
        },
        scopedSlots: _vm._u([
          {
            key: "content-left",
            fn: function () {
              return [
                _vm.step == 1
                  ? _c(
                      "v-list",
                      {
                        staticClass: "pa-0",
                        attrs: { dense: "", "two-line": "" },
                      },
                      [
                        _c(
                          "v-expansion-panels",
                          {
                            model: {
                              value: _vm.navigationExpansion,
                              callback: function ($$v) {
                                _vm.navigationExpansion = $$v
                              },
                              expression: "navigationExpansion",
                            },
                          },
                          [
                            _c(
                              "v-expansion-panel",
                              [
                                _c("v-expansion-panel-header", [
                                  _vm._v("Navigation"),
                                ]),
                                _c(
                                  "v-expansion-panel-content",
                                  [
                                    _c(
                                      "v-list-item-group",
                                      {
                                        class:
                                          _vm.currentBreakpoint <= 3
                                            ? "d-flex"
                                            : "",
                                        attrs: {
                                          value: _vm.selectedNavigationItem,
                                          mandatory: "",
                                          color: "primary",
                                        },
                                      },
                                      [
                                        _c("NavigationItem", {
                                          attrs: {
                                            disabled:
                                              _vm.courseNavigationDisabled ||
                                              _vm.isLoading,
                                            icon: "mdi-weight-lifter",
                                            label:
                                              _vm.$t(
                                                "overview.tab_label_courses"
                                              ) +
                                              " " +
                                              (_vm.courseNavigationDisabled
                                                ? _vm.$t(
                                                    "overview.tab_label_deactivated"
                                                  )
                                                : ""),
                                            subLabel: _vm.navSubTitleCourses,
                                            value: _vm.NAV_COURSEBOOKING,
                                          },
                                          on: {
                                            onClick:
                                              _vm.handleNavigationItemClick,
                                          },
                                        }),
                                        _c("NavigationItem", {
                                          attrs: {
                                            disabled:
                                              _vm.hallNavigationDisabled ||
                                              _vm.isLoading,
                                            icon: "mdi-soccer-field",
                                            label:
                                              _vm.$t(
                                                "overview.tab_label_halls"
                                              ) +
                                              " " +
                                              (_vm.hallNavigationDisabled
                                                ? _vm.$t(
                                                    "overview.tab_label_deactivated"
                                                  )
                                                : ""),
                                            subLabel: _vm.navSubTitleHalls,
                                            value: _vm.NAV_HALLBOOKING,
                                          },
                                          on: {
                                            onClick:
                                              _vm.handleNavigationItemClick,
                                          },
                                        }),
                                        _c("NavigationItem", {
                                          attrs: {
                                            disabled: _vm.isLoading,
                                            icon: "mdi-account-cash",
                                            label: _vm.$t(
                                              "overview.tab_label_myBookings"
                                            ),
                                            subLabel: _vm.$t(
                                              "overview.tab_subLabel_myBookings"
                                            ),
                                            value: _vm.NAV_MYBOOKINGS,
                                          },
                                          on: {
                                            onClick:
                                              _vm.handleNavigationItemClick,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("AccountInfoVue", {
                          attrs: { loading: _vm.isLoading },
                          on: { onLogoutClick: _vm.handleLogout },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "content-center",
            fn: function () {
              return [
                _c(
                  "v-dialog",
                  {
                    attrs: { persistent: "", "max-width": "290" },
                    model: {
                      value: _vm.showLogoutDialog,
                      callback: function ($$v) {
                        _vm.showLogoutDialog = $$v
                      },
                      expression: "showLogoutDialog",
                    },
                  },
                  [
                    _c(
                      "v-card",
                      [
                        _c("v-card-title", { staticClass: "text-h5" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("common.label_logout")) + " "
                          ),
                        ]),
                        _c("v-card-text", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("common.logout_confirmation_message")
                              ) +
                              " "
                          ),
                        ]),
                        _c(
                          "v-card-actions",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "green darken-1", text: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.resetApplication()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("common.label_yes")) + " "
                                ),
                              ]
                            ),
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "red darken-1", text: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.showLogoutDialog = false
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("common.label_no")) + " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.step == 1
                  ? _c(
                      "v-tabs-items",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { touchless: "" },
                        model: {
                          value: _vm.selectedNavigationItem,
                          callback: function ($$v) {
                            _vm.selectedNavigationItem = $$v
                          },
                          expression: "selectedNavigationItem",
                        },
                      },
                      [
                        _c(
                          "v-tab-item",
                          {
                            attrs: {
                              value: _vm.NAV_COURSEBOOKING,
                              disabled: "",
                            },
                          },
                          [
                            _vm.step == 1 &&
                            _vm.selectedNavigationItem === _vm.NAV_COURSEBOOKING
                              ? _c("Overview", {
                                  attrs: {
                                    isBooking: _vm.loading.booking,
                                    isReservating: _vm.loading.reservating,
                                    searchFor: _vm.currentSearch,
                                    sortBy: _vm.currentSort,
                                    filterFor: _vm.currentFilter,
                                    bookingType: _vm.TYPE_COURSES,
                                    loadingElem: _vm.loading.details,
                                  },
                                  on: {
                                    stepChanged: _vm.handleOverviewStepChange,
                                    onPreviewItemSelect:
                                      _vm.handleCourseSelection,
                                    onRemoveBookingButtonClick:
                                      _vm.handleCourseBookingCancellation,
                                    onRemoveReservationButtonClick:
                                      _vm.handleCourseReservationCancellation,
                                    onAddReservationButtonClick:
                                      _vm.handleCourseReservation,
                                    onFinishedPayment:
                                      _vm.handleFinishedPayment,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "v-tab-item",
                          { attrs: { value: _vm.NAV_HALLBOOKING } },
                          [
                            _vm.step == 1 &&
                            _vm.selectedNavigationItem === _vm.NAV_HALLBOOKING
                              ? _c("Overview", {
                                  attrs: {
                                    searchFor: _vm.currentSearch,
                                    sortBy: _vm.currentSort,
                                    filterFor: _vm.currentFilter,
                                    bookingType: _vm.TYPE_HALLS,
                                    loadingElem: _vm.loading.details,
                                  },
                                  on: {
                                    stepChanged: _vm.handleOverviewStepChange,
                                    onPreviewItemSelect:
                                      _vm.handleHallSelection,
                                    onRemoveBookingButtonClick:
                                      _vm.handleHallBookingCancellation,
                                    onHallBookingInput:
                                      _vm.handleHallBookingInput,
                                    onMeetingClick: _vm.handleMeetingClick,
                                    onFinishedPayment:
                                      _vm.handleFinishedPayment,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "v-tab-item",
                          { attrs: { value: _vm.NAV_MYBOOKINGS } },
                          [
                            _vm.step == 1 &&
                            _vm.selectedNavigationItem === _vm.NAV_MYBOOKINGS
                              ? _c("Overview", {
                                  attrs: {
                                    isBooking: _vm.loading.booking,
                                    isReservating: _vm.loading.reservating,
                                    loadingElem: _vm.loading.details,
                                    bookingType: _vm.TYPE_BOOKINGS,
                                  },
                                  on: {
                                    stepChanged: _vm.handleOverviewStepChange,
                                    onPreviewItemSelect:
                                      _vm.handleMyBookingsSelection,
                                    onRemoveBookingButtonClick:
                                      _vm.handleBookingCancellationMyBookings,
                                    onRemoveReservationButtonClick:
                                      _vm.handleCourseReservationCancellation,
                                    onHallBookingInput:
                                      _vm.handleHallBookingInput,
                                    onMeetingClick: _vm.handleMeetingClick,
                                    onFinishedPayment:
                                      _vm.handleFinishedPayment,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "content-right",
            fn: function () {
              return [
                _vm.selectedNavigationItem == _vm.NAV_COURSEBOOKING
                  ? _c("OverviewSorter", {
                      attrs: {
                        disabled: _vm.isLoading,
                        availableSorts: _vm.getCourseSorts(),
                        availableFilters: _vm.getCourseFilters(),
                        bookingType: _vm.TYPE_COURSES,
                      },
                      on: {
                        onSearch: _vm.handleSearch,
                        onSort: _vm.handleSort,
                        onFilter: _vm.handleFilter,
                      },
                    })
                  : _vm._e(),
                _vm.selectedNavigationItem == _vm.NAV_HALLBOOKING
                  ? _c("OverviewSorter", {
                      attrs: {
                        disabled: _vm.isLoading,
                        availableSorts: _vm.getHallSorts(),
                        availableFilters: _vm.getHallFilters(),
                        bookingType: _vm.TYPE_HALLS,
                      },
                      on: {
                        onSearch: _vm.handleSearch,
                        onSort: _vm.handleSort,
                        onFilter: _vm.handleFilter,
                      },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }